import { render, staticRenderFns } from "./OrdersummaryDl.vue?vue&type=template&id=68348991&"
import script from "./OrdersummaryDl.vue?vue&type=script&lang=js&"
export * from "./OrdersummaryDl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports